/**
 * A map that can appended to easily
 */
type Value<K, V> = Map<K, Set<V>>;

export function appendMap<K extends string, V>(): {
    append: (key: K, value: V) => Value<K, V>;
    values: Value<K, V>;
} {
    const values = new Map<K, Set<V>>();
    function append(key: K, id: V) {
        if (values.has(key)) {
            values.get(key)!.add(id);
        } else {
            values.set(key, new Set([id]));
        }
        return values;
    }
    return { append, values };
}
